import React from "react";
import ProductyoutubeCSS from "./Product_youtube.module.css";
import { Link } from "react-router-dom";

function Product_youtube() {
  return (
    <div className={ProductyoutubeCSS.baseStart}>
      <img className={ProductyoutubeCSS.back} src="img/en/product_2_1.png" alt="smartooth" />
      <div className={ProductyoutubeCSS.videoWrap}>
        <iframe
          id="video"
          width="100%"
          height="82%"
          src="https://www.youtube-nocookie.com/embed/voCRZf2fkJY"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        ></iframe>
      </div>
    </div>
  );
}
export default Product_youtube;
